import React, { useState, useRef, useEffect } from 'react';
import { Tabs, Tab, Box, Typography, IconButton, Slider, withWidth } from '@material-ui/core';
import { PlayArrow, Pause, VolumeUp } from '@material-ui/icons';
import "./AudioStreaming.css";

const AudioPlayer = ({ streams }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [sliderValue, setSliderValue] = useState(0.7)
  const [stream, setStream] = useState('');
  const [pause, setPause] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.load();
    }
  }, [activeTab]);

  useEffect(() => {
    if (isPlaying && stream === 'startStream') {
      audioRef.current.play();
    } else {
      audioRef.current.pause();
    }
  }, [isPlaying]);

  const handleChangeTab = (event, newTab) => {
    setActiveTab(newTab);
    setIsPlaying(false);
  };

  const handleCanPlay = () => {
    if (audioRef.current.duration - audioRef.current.currentTime < 1) {
        // If close to the end of the audio, set currentTime slightly before the end
        audioRef.current.currentTime = audioRef.current.duration - 1;
    }
    if(stream === 'startStream'){
        setIsPlaying(true);
    }
  };

  const handleSliderValue = (event, newValue) => {
    setSliderValue(newValue);
    if(pause){
        audioRef.current.volume = newValue;
    }
  };

  const handlePause = () => {
    if(pause){
        audioRef.current.volume = 0
    } else {
        audioRef.current.volume = sliderValue
    }
    setPause(!pause)
    setStream('startStream')
    setIsPlaying(true)
  }

  return (
    <div className='audio-container'>

        <h1>Audio Streaming</h1>
        <div className='tabs'>
      <Tabs value={activeTab} onChange={handleChangeTab} variant="fullWidth" indicatorColor='primary' centered       >
        {streams.map((stream, index) => (
          <Tab key={index} label={stream.title} disabled={activeTab === index}  style={{ margin:'0px -30px'}}   />
        ))}
      </Tabs>
      </div>
      <div className='box-container'>

      <Box sx={{
        display:"flex",
        alignItems:"center",
        height: 650,
        backgroundColor: 'primary.dark',
        '&:hover': {
          backgroundColor: 'primary.main',
          opacity: [0.9, 0.8, 0.7],
        },
      }} p={1}>
        <div className='logo-cons'>
        <img src={streams[activeTab].image}></img>
        <audio
          ref={audioRef}
          controls
          src={streams[activeTab].url}
          onCanPlay={handleCanPlay}
          hidden
        />
        </div>
        <div className='station-cons'>
        <div className='station-description'>
            <h1>{streams[activeTab].name}</h1>
            <p>{streams[activeTab].desc}</p>
        <div className='player-buttons'>

        <IconButton onClick={handlePause}>
          {pause ? <Pause /> : <PlayArrow />}
        </IconButton>
        <Slider
          value={sliderValue}
          onChange={handleSliderValue}
          min={0}
          max={1}
          step={0.01}
          disabled={false}


        />
        </div>
        </div>

        </div>

      </Box>
      </div>
    </div>
  );
};

export default AudioPlayer;